module.exports = "/_next/static/images/electric-62a4754614c64a5bbce468f513cba40e.jpg";